module.exports = __webpack_public_path__ + "img/text-left.f3ec7798.svg";